import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { TransfersRepository } from '@core/repositories/transfers.repository';
import { SearchCustomer, SearchReference, TransferEdit } from '@shared/interfaces/transfer';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiTransfersRepository implements TransfersRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  private setHeaders(page: string) {
    return {
      headers: new HttpHeaders({
        'page-size': '10',
        page: page
      })
    };
  }

  getItems(): Observable<any> {
    return this.http.get('');
  }

  getItemId(data: SearchReference): Observable<any> {
    const search = {
      data: {
        attributes: {
          channel: data.channel,
          reference: data.reference,
          user: data.user
        },
        type: 'Transfers'
      }
    };
    return this.http.post(
      this.appConfig.SERVICES.transfersReference.findbyreference.url,
      search
    );
  }

  getItemSearch(data: SearchCustomer) {
    let dateStart = '',
      dateEnd = '';
    if (data.dateStart) {
      dateStart = data.dateStart
        .startOf('day')
        .format(this.appConfig.DATE_FORMAT_SEARCH);
    }
    if (data.dateEnd) {
      dateEnd = data.dateEnd
        .endOf('day')
        .format(this.appConfig.DATE_FORMAT_SEARCH);
    }

    const search = {
      data: {
        attributes: {
          channel: data.channel,
          'document-number': data.identify,
          'document-type': data.typeIdentify,
          'end-date': dateEnd,
          role: data.rol,
          'start-date': dateStart,
          user: data.user
        },
        type: 'Transfers'
      }
    };
    return this.http.post(
      this.appConfig.SERVICES.transfersCustomer.findbycustomerdate.url,
      search,
      this.setHeaders(data.page.toString())
    );
  }

  validateEdit(data: SearchReference) {
    return this.http.get(
      this.appConfig.SERVICES.transfersReference.canupdatecellphone.url +
        '/' +
        data.reference
    );
  }

  validateCancel(data: SearchReference) {
    return this.http.get(
      this.appConfig.SERVICES.transfersReference.canavoid.url +
        '/' +
        data.reference
    );
  }

  validateReverse(data: SearchReference) {
    return this.http.get(
      this.appConfig.SERVICES.transfersReference.canreverseadm.url +
        '/' +
        data.reference
    );
  }

  edit(transfer: TransferEdit) {
    const data = {
      data: {
        attributes: {
          cellphone: transfer.cell,
          role: transfer.rol,
          reference: transfer.reference
        },
        type: 'Transfers'
      }
    };
    return this.http.put(
      this.appConfig.SERVICES.transfersReference.updatecellphone.url,
      data
    );
  }

  editId(transfer: TransferEdit) {
    const data = {
      data: {
        attributes: {
          document: transfer.identify,
          role: transfer.rol,
          reference: transfer.reference
        },
        type: 'Transfers'
      }
    };
    return this.http.put(
      this.appConfig.SERVICES.transfersReference.updatedocument.url,
      data
    );
  }

  cancel(data: SearchReference) {
    const item = {
      data: {
        attributes: {
          channel: data.channel,
          reference: data.reference,
          username: data.user
        },
        type: 'Transfers'
      }
    };
    return this.http.post(
      this.appConfig.SERVICES.transfersReference.avoid.url,
      item
    );
  }

  reversed(data: SearchReference) {
    const item = {
      data: {
        attributes: {
          channel: data.channel,
          reference: data.reference,
          username: data.user
        },
        type: 'Transfers'
      }
    };
    return this.http.post(
      this.appConfig.SERVICES.transfersReference.reverseadm.url,
      item
    );
  }
}
